import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowUpFromLineRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.293 9.707a1 1 0 0 0 1.414 0L11 7.413v8.088a1 1 0 1 0 2 0V7.414l2.293 2.293a1 1 0 0 0 1.414-1.415l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 0 1.415Zm-3.294 9.295a1 1 0 0 1 1-1h14.003a1 1 0 0 1 0 2H4.999a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowUpFromLineRound);
export default Memo;
